<div class="about-panel">
  <div class="about-panel__header">
    <span class="about-panel__title">{{ 'ABOUT.TITLE' | transloco }}</span>
    <button class="about-panel__close-btn" (click)="close()" [attr.aria-label]="'BUTTONS.CLOSE' | transloco">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div class="about-panel__body">
    

    <p class="about-panel__section-label mt-20">{{ 'ABOUT.RESOURCES' | transloco }}</p>

    <div class="about-panel__card">
      <div *ngFor="let link of resourceLinks; let last = last" class="about-panel__link-row" [class.about-panel__link-row--last]="last" (click)="openLink(link.url)">
        <div class="about-panel__link-icon-box" [ngStyle]="{'background-color': link.iconBg}">
          <mat-icon [svgIcon]="link.icon"></mat-icon>
        </div>
        <span class="about-panel__link-label">{{ link.labelKey | transloco }}</span>
        <mat-icon class="about-panel__external-icon" svgIcon="open_in_new"></mat-icon>
      </div>
    </div>
    <p class="about-panel__section-label mt-20">{{ 'ABOUT.BUILD_DETAILS' | transloco }}</p>

    <div class="about-panel__card">
      <div *ngFor="let row of buildRows; let last = last" class="about-panel__info-row" [class.about-panel__info-row--last]="last">
        <mat-icon class="about-panel__row-icon" [svgIcon]="row.icon" [ngStyle]="{'color': row.color}"></mat-icon>
        <div class="about-panel__row-content">
          <p class="about-panel__row-label">{{ row.labelKey | transloco }}</p>
          <p class="about-panel__row-value">{{ (row.value && !row.value.startsWith('__')) ? row.value : '-' }}</p>
        </div>
      </div>
    </div>

  </div>
</div>
